import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const brand = palette('#FF9A33');

export const iccTheme = definePreset(Aura, {
  primitive: {
    // Override sky with secondary brand color - used by severity="info" on components
    sky: palette('#114C5B'),
  },

  semantic: {
    iconSize: '1rem',
    primary: {
      50: brand[50],
      100: brand[100],
      200: brand[200],
      300: brand[300],
      400: brand[400],
      500: brand[500],
      600: brand[600],
      700: brand[700],
      800: brand[800],
      900: brand[900],
      950: brand[950],
    },
  },
});
